import {createAction} from 'redux-actions';
import {Tenant} from '../api/types';

export interface UserAuthenticatedPayload {
    permissions: string[];
    roles: string[];
}

export interface TenantSelectedPayload {
    tenant: Tenant|null;
}

export const userAuthenticated = createAction<UserAuthenticatedPayload>('USER_AUTHENTICATED');
export const tenantSelected = createAction<TenantSelectedPayload>('TENANT_SELECTED');
export const allTenantDependentDataCleared = createAction<{}>('ALL_TENANT_DEPENDENT_DATA_CLEARED');
